import BarChart from 'components/charts/BarChart';
import {barChartDataDailyTraffic, barChartOptionsDailyTraffic} from 'variables/charts';
import Card from 'components/card';
import {AccountSummaryResponse} from '../../../../stores/types';
import {formatCurrency} from '../../../../stores/JSHelper';

const DailyTraffic = (props: {summary: AccountSummaryResponse}) => {
  return (
    <Card extra="pb-7 p-[20px]">
      <div className="flex flex-row justify-between">
        <div className="ml-1 pt-2">
          <h2 className="text-lg font-bold text-navy-700 dark:text-white">Top Wallet Balances</h2>
        </div>
        <div className="mt-2 flex items-start">
          <div className="flex items-center">
            <div className="font-bold text-right">
              Median
              <div className="text-2xl">{formatCurrency(props.summary.walletStats.medianWalletBalance, 'INR', true)}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="h-[300px] w-full pb-0 pt-10">
        <BarChart chartData={barChartDataDailyTraffic(props.summary)} chartOptions={barChartOptionsDailyTraffic(props.summary)} />
      </div>
    </Card>
  );
};

export default DailyTraffic;
